import { render, staticRenderFns } from "./rFiles.vue?vue&type=template&id=1a4dfe5c"
import script from "./rFiles.vue?vue&type=script&lang=js"
export * from "./rFiles.vue?vue&type=script&lang=js"
import style0 from "./rFiles.vue?vue&type=style&index=0&id=1a4dfe5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports